module.exports = __webpack_public_path__ + "static/media/poop.0595c908.svg";